export enum EFileState {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE'
}
